import { render, staticRenderFns } from "./AsidePanel.vue?vue&type=template&id=4c543702&"
import script from "./AsidePanel.vue?vue&type=script&lang=js&"
export * from "./AsidePanel.vue?vue&type=script&lang=js&"
import style0 from "./AsidePanel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports